import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WarnEnrollNonSilverComponent } from '../warn-enroll-non-silver/warn-enroll-non-silver.component';

@Component({
    selector: 'app-no-enroll-catastrophic-modal',
    templateUrl: './no-enroll-catastrophic-modal.component.html',
    styleUrls: ['./no-enroll-catastrophic-modal.component.scss'],
    standalone: false
})
export class NoEnrollCatastrophicModalComponent implements OnInit {

  regionPhones: {
    'WPA': '1-855-329-1760',
    'CPA': '1-855-329-1761',
    'WV': '1-855-329-1763',
    'DE': '1-855-329-1764',
    'NEPA': '1-855-856-0317',
    'ND': '800-280-2583',
    'WY': ''
  };

  constructor(
    private dialogRef: MatDialogRef<WarnEnrollNonSilverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      region: string
    }
  ) { }

  ngOnInit(): void {
  }
  closeModal() {
    this.dialogRef.close();
  }

}
